import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@material-ui/core'
import { useConfig } from 'hooks/useConfig'
import axios from 'axios'

const RailcarVisitVoid = ({ open, handleClose, handleVoided, inventoryRowId, inventoryId, currentTerminal }) => {
  const { config } = useConfig()
  const [reason, setReason] = useState('')
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)
  const voidDisabled = submitting || !reason.trim()

  const handleVoid = async () => {
    setSubmitting(true)
    try {
      await axios.post(`${config.LOGITRAC_API_URL}api/railcar-visits/void`, {
        inventoryRowId,
        currentTerminal,
        reason
      })
      handleVoided()
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to void visit')
      setSubmitting(false)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={submitting ? undefined : handleClose}
      aria-labelledby="void-visit-title"
      aria-describedby="void-visit-description"
    >
      <DialogTitle id="void-visit-title">{`Void the current visit for ${inventoryId}?`}</DialogTitle>
      <DialogContent>
        <DialogContentText id="void-visit-description">
          Use this only for a railcar that is not really here, such as one uploaded back on track by mistake. Its
          current visit is removed from the railcar reports and the car is set to <strong>Not At Facility</strong>. No
          release is billed.
        </DialogContentText>
        <TextField
          label="Reason"
          value={reason}
          onChange={e => setReason(e.target.value)}
          fullWidth
          required
          multiline
          margin="normal"
          helperText="Saved with the voided visit, along with your name."
        />
        {error && <DialogContentText style={{ color: '#ef5350' }}>{error}</DialogContentText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          onClick={handleVoid}
          disabled={voidDisabled}
          style={{
            ...(voidDisabled
              ? { backgroundColor: 'rgba(0, 0, 0, 0.12)', color: 'rgba(0, 0, 0, 0.26)' }
              : { backgroundColor: '#ef5350', color: 'white' }),
            padding: '9px 20px',
            marginLeft: '30px'
          }}
        >
          Void Visit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RailcarVisitVoid
